// load-swiper.js
(function() {
  if (window.Swiper) return; // already loaded

  const swiperScript = document.createElement('script');
  swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  swiperScript.onload = function() {
    console.log('Swiper JS loaded');
    document.dispatchEvent(new CustomEvent('swiper:ready'));
  };

  const swiperStyle = document.createElement('link');
  swiperStyle.rel = 'stylesheet';
  swiperStyle.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

  document.head.appendChild(swiperStyle);
  document.head.appendChild(swiperScript);
})();
